import React, { useState, useEffect } from "react";
import EilgableHoursPanel from "./EilgableHoursPanel";
import UtilizationPanel from "./UtilizationPanel";
import { Container, Row, Col, Card } from "react-bootstrap";
import TotalAvailableRevSharePanel from "../common/TotalAvailableRevSharePanel";
import BlackoutAlert from "../../common/alerts/BlackoutAlert";
import { getForConsultant } from "../../../apis/revshare/EligableHoursApi";
import { getUtilization } from "../../../apis/revshare/UtilizationApi";
import { cashOutBlackoutIsActive } from "../../../apis/revshare/UtilitiesApi";

const DashboardPage = ({ profile }) => {
  // Local state
  const [eligableHours, setEligableHours] = useState({});
  const [utilization, setUtilization] = useState({});
  const [blackedOut, setBlackedOut] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [employeeNumber] = useState(profile.employeeId);

  // Load all data
  useEffect(() => {
    async function fetchData() {
      setIsLoading(true);
      
      try {
        // Load blackout status
        const blackoutStatus = await cashOutBlackoutIsActive();
        setBlackedOut(blackoutStatus);
        
        // Load eligible hours
        const hoursData = await getForConsultant(employeeNumber);
        setEligableHours(hoursData);
        
        // Load utilization
        const utilizationData = await getUtilization(employeeNumber);
        setUtilization(utilizationData);
        
      } catch (error) {
        console.error("Error loading dashboard data:", error);
      } finally {
        setIsLoading(false);
      }
    }

    fetchData();
  }, [employeeNumber]);

  return (
    <Container fluid>
      <Row>
        <TotalAvailableRevSharePanel />
      </Row>
      {blackedOut && (
        <Row>
          <Col></Col>
          <Col xs="auto">
            <Card className="popout-element">
              <Card.Body>
                <BlackoutAlert />
              </Card.Body>
            </Card>
          </Col>
          <Col></Col>
        </Row>
      )}
      <Row>
        <Col>
          <EilgableHoursPanel 
            data={eligableHours} 
            isLoaded={!isLoading}
          />
        </Col>
        <Col>
          <UtilizationPanel 
            data={utilization} 
            isLoaded={!isLoading}
          />
        </Col>
      </Row>
    </Container>
  );
};

export default DashboardPage;